import { render, staticRenderFns } from "./CreatePostController.vue?vue&type=template&id=35e386a4&scoped=true&"
import script from "./CreatePostController.vue?vue&type=script&lang=ts&"
export * from "./CreatePostController.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePostController.vue?vue&type=style&index=0&id=35e386a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e386a4",
  null
  
)

export default component.exports